// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1E92H","list":"styles_list__3YRYN"};